import { ImportacaoListSearchComponent } from './ImportacaoListSearchComponent'
import { ImportacaoListToolbar } from './ImportacaoListToolbar'

const ImportacaoListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <ImportacaoListSearchComponent actions={<ImportacaoListToolbar />} />
    </div>
  )
}

export { ImportacaoListHeader }
